<template>
  <div>
    <v-container
      fluid
      class="d-flex align-center justify-center"
      style="min-height: 90vh"
    >
      <v-row align="center" justify="center" class="mx-2">
        <v-col cols="12" sm="10" md="6" lg="4">
          <v-card
            class="pa-4 pa-sm-6"
            elevation="6"
            rounded="xl"
            style="background: #f9f9f9"
          >
            <v-card-text
              class="d-flex flex-column align-center"
              v-if="ExpiredStatus == false"
            >
              <v-img
                alt="Logo"
                class="mx-auto cursor-pointer"
                contain
                src="@/assets/logoFS.svg"
                transition="scale-transition"
                max-width="220"
                :width="$vuetify.breakpoint.smAndDown ? 150 : 220"
              />
              <p
                class="text-h6 font-weight-bold mt-4 text-center"
                style="color: #3f51b5"
              >
                {{ visitorName }}
              </p>
              <v-img
                alt="Logo"
                class="mx-auto cursor-pointer"
                contain
                :src="QRvalue"
                transition="scale-transition"
              />
              <p
                class="text-subtitle-1 font-weight-bold mt-3 text-center"
                style="color: #424242"
              >
                {{ startDate }}
              </p>
              <p
                class="text-subtitle-1 font-weight-bold text-center"
                style="color: #424242"
              >
                {{ expireDate }}
              </p>
              <p
                class="text-subtitle-1 font-weight-bold mt-4 text-center"
                style="color: #424242"
              >
                {{ CreateTime }}
              </p>
              <v-btn
                color="indigo"
                class="white--text mt-4"
                height="40"
                :width="$vuetify.breakpoint.smAndDown ? 120 : 150"
                @click="copyURL()"
              >
                Copy Link
              </v-btn>

              <div class="mt-6 d-flex align-center justify-center flex-wrap">
                <span class="text-body-2 mr-1" style="color: #424242"
                  >Refresh In :</span
                >
                <span
                  class="text-body-2 font-weight-bold"
                  style="color: #4caf50"
                  >{{ TextTime }}</span
                >
              </div>
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center" v-else>
              <v-img
                alt="Logo"
                class="mx-auto cursor-pointer"
                contain
                src="@/assets/logoFS.svg"
                transition="scale-transition"
                :width="$vuetify.breakpoint.smAndDown ? 150 : 220"
              />
              <p
                class="text-h6 font-weight-bold mt-6 text-center"
                style="color: #3f51b5"
              >
                {{ MessageReturn }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
// import QrcodeVue from "qrcode.vue";

export default {
  name: "QRPreRegister",
  components: {
    // QrcodeVue,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRvalue: "",
      QRsize: 250,
      Detail: "",
      startDate: "",
      expireDate: "",
      CreateTime: "",
      TextTime: "",
      visitorName: "",
      ExpiredStatus: false,
      MessageReturn: "",
    };
  },

  async mounted() {
    let self = this;
    let url = window.location.href;
    if (url != "") {
      let url_text = url.split("/");
      self.getQRPreRegister(url_text[url_text.length - 1]);
    }
  },

  methods: {
    getQRPreRegister(uid) {
      let self = this;
      let temp = {
        invite_uid: uid,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}PreRegister/getQRPreRegisterByUid`, temp)
        .then(function (response) {
          const res = response.data;
          if (res.status === 0 && res.data) {
            self.QRvalue = "data:image/png;base64," + response.data.data.qrData;
            self.CreateTime = response.data.data.createDate;
            self.startDate = response.data.data.startDate;
            self.expireDate = response.data.data.expireDate;
            self.visitorName = response.data.data.visitorName;
            self.countdown(response.data.data.durationTime, 0);
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            const res = error.response.data;
            if (res.status === 1) {
              this.ExpiredStatus = true;
              this.MessageReturn = res.message;
              this.QRvalue = null;
              return;
            }
          }
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }

          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          this.LoadingDialog = false;
        });
    },

    copyURL() {
      let url = window.location.href;
      navigator.clipboard.writeText(url);
      Swal.fire({
        icon: "success",
        title: "Copy Link",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    countdown(minutes, seconds) {
      let self = this;
      var endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? "0" + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          let url = window.location.href;
          if (url != "") {
            let url_text = url.split("/");
            self.getQRPreRegister(url_text[url_text.length - 1]);
          }
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          self.TextTime =
            (hours ? hours + ":" + twoDigits(mins) : mins) +
            ":" +
            twoDigits(time.getUTCSeconds());
          setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
      }
      endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
      updateTimer();
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped>
</style>
    